import PANOMNOM from '../../third_party/PanomNom';

let loader = null;

export default () => {
  if (!loader) {
    loader = new PANOMNOM.GooglePhotoSphereLoader();
  }

  return loader;
};
